export class Global {
    static NOMBRE_SISTEMA = 'Micro-Red';
    static SIZE_GET_ALL = 999999999;
    static PREFIX_RECORD = 'microred';

    static MAESTRO = 'maestro';
    static TRANSACCION = 'transaccion';

    static DASHBOARD = ['pages', 'home', 'dashboard'];
    static LOGOUT = ['auth', 'logout'];
    static LOGIN = ['auth', 'login'];

    static MESSAGE_DETAIL = 'No Encontrado';
    static MESSAGE_SESSION_EXPIRED = 'Sesión Expirada';
    static MESSAGE_REDIRECT = 'Lo vamos a redirigir para que vuelva a ingresar';

    static TYPES = {
        OR: 'or',
        UNIQUE: 'unique',
        ID: 'id',
        MANUMERIC: 'manumeric',
        MENUMERIC: 'menumeric',
        NUMERIC: 'numeric',
        TEXT: 'text',
        BOOLEAN: 'boolean',
        REF: 'ref',
    };

    static MENU: Record<string, any> = {
        seguridad: {
            codigo: 'seguridad',
            nombre: 'Seguridad',
            routerLink: 'seguridad',
            registros: {
                usuario: {
                    codigo: 'usuario',
                    nombre: 'Usuarios',
                    routerLink: 'usuarios',
                },
                grupo_accceso: {
                    codigo: 'grupo_acceso',
                    nombre: 'Grupos de Acceso',
                    routerLink: 'grupos-acceso',
                },
            },
        },
        administracion: {
            codigo: 'administracion',
            nombre: 'Administracion',
            routerLink: 'administracion',
            registros: {
                caja: { codigo: 'caja', nombre: 'Cajas', routerLink: 'cajas' },
                empresa: {
                    codigo: 'empresa',
                    nombre: 'Empresas',
                    routerLink: 'empresas',
                },
                sucursal: {
                    codigo: 'sucursal',
                    nombre: 'Sucursales',
                    routerLink: 'sucursales',
                },
                acreditacion: {
                    codigo: 'acreditacion',
                    nombre: 'Acreditaciones',
                    routerLink: 'acreditaciones',
                },
                vendedor: {
                    codigo: 'vendedor',
                    nombre: 'Vendedores',
                    routerLink: 'vendedores',
                },
                solicitud_cambio_limite_credito: {
                    codigo: 'solicitud_cambio_limite_credito',
                    nombre: 'Solicitud Limite de Credito',
                    routerLink: 'solicitud-cambio-limite-credito',
                },
            },
            reportes: {
                lista_acreditacion: {
                    codigo: 'lista_acreditacion',
                    nombre: 'Lista de Acreditaciones',
                    routerLink: 'lista-acreditacion',
                },
                resumen_movimiento: {
                    codigo: 'resumen_movimiento',
                    nombre: 'Resumen General de Movimientos',
                    routerLink: 'resumen-movimiento',
                },
                historial_acreditacion: {
                    codigo: 'historial_acreditacion',
                    nombre: 'Historial de Acreditaciones',
                    routerLink: 'historial-acreditacion',
                },
            },
            procesos: {},
        },
        configuracion: {
            codigo: 'configuracion',
            nombre: 'Configuración',
            routerLink: 'configuracion',
            registros: {
                entidad: {
                    codigo: 'entidad',
                    nombre: 'Entidades',
                    routerLink: 'entidades',
                },
                clasificacion: {
                    codigo: 'clasificacion',
                    nombre: 'Clasificaciones',
                    routerLink: 'clasificaciones',
                },
                comercio: {
                    codigo: 'comercio',
                    nombre: 'Comercios',
                    routerLink: 'comercios',
                },
                servicio: {
                    codigo: 'servicio',
                    nombre: 'Servicios',
                    routerLink: 'servicios',
                },
                perfil_servicio: {
                    codigo: 'perfil_servicio',
                    nombre: 'Perfiles de Servicios',
                    routerLink: 'perfiles-servicios',
                },
                grupo_comercio: {
                    codigo: 'grupo_comercio',
                    nombre: 'Grupo de Comercios',
                    routerLink: 'grupo-comercio',
                },
                grupo_servicio: {
                    codigo: 'grupo_servicio',
                    nombre: 'Grupo de Servicios',
                    routerLink: 'grupo-servicio',
                },
            },
            reportes: {
                servicio_documenta: {
                    codigo: 'servicio_documenta',
                    nombre: 'Servicios Documenta',
                    routerLink: 'servicios-documenta',
                },
                servicio_activo: {
                    codigo: 'servicio_activo',
                    nombre: 'Servicios Pronet',
                    routerLink: 'servicios-pronet',
                },
                servicio_cabal: {
                    codigo: 'servicio_cabal',
                    nombre: 'Servicios Cabal',
                    routerLink: 'servicios-cabal',
                },
                habilitar_comercio: {
                    codigo: 'habilitar_comercio',
                    nombre: 'Habilitar Comercio de Grupo',
                    routerLink: 'habilitar-comercio',
                },
                agrupar_servicios: {
                    codigo: 'agrupar_servicios',
                    nombre: 'Agrupar Servicios',
                    routerLink: 'agrupar-servicios',
                },
            },
            procesos: {},
        },
        cobranza: {
            codigo: 'cobranza',
            nombre: 'Cobranza',
            routerLink: 'cobranza',
            registros: {
                arqueo_caja: {
                    codigo: 'arqueo_caja',
                    nombre: 'Arqueos de Caja',
                    routerLink: 'arqueos-caja',
                },
                cobro: {
                    codigo: 'cobro',
                    nombre: 'Cobros',
                    routerLink: 'cobros',
                },
            },
            reportes: {
                listado_cobro: {
                    codigo: 'listado_cobro',
                    nombre: 'Listado de Cobros',
                    routerLink: 'lista-cobro',
                },
                lista_cobro_general: {
                    codigo: 'lista_cobro_general',
                    nombre: 'Listado General de Cobros',
                    routerLink: 'lista-cobro-general',
                },
            },
            procesos: {
                recalcular_comision: {
                    codigo: 'recalcular_comision',
                    nombre: 'Recalcular Comision',
                    routerLink: 'recalcular-comision',
                },
            },
        },
    };

    static TRXS = {
        consulta: 'CONSULTA',
        pago: 'PAGO',
        codigo_barra: 'CODIGO_BARRA',
    };

    static PRONET = {
        codigo: 'pronet',
        parametros: 'PARAMETROS',
        consulta: 'CONSULTA',
        pago: ['CONSULTA', 'PAGO', 'BATCH'],
    };

    static CABAL = {
        codigo: 'cabal',
        parametros: 'PARAMETROS',
        consulta: 'CONSULTA',
        pago: ['CONSULTA', 'PAGO', 'BATCH'],
    };

    static CAMPOS = {
        EDITABLE: 'editable',
        NOMBRE: 'nombre',
        OCULTAR: 'ocultar',
        REFERENCIA: 'referencia',
        REQUERIDO: 'requerido',
        TIPO: 'tipo',
        TITULO: 'titulo',
        ETIQUETA: 'etiqueta',
        VALOR: 'valor',
    };

    static TRUE_STRING = 'true';
    static FALSE_STRING = 'false';

    static LOGO_IMAGE: string = 'assets/images/finamsa/logo-';
    static IMAGE_EXT: string = '.png';
    static BACKGROUND_IMAGE: string = 'background:var(--exception-pages-image)';
}

interface IMenuRegistro {
    codigo: string;
    nombre: string;
    routerLink: string;
}
